(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement-coupon"] && !Shopify.designMode) return;
  try {
    class CopyCoupon extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('.announcement-coupon__btn');
      this.codeEl = this.querySelector('[data-role="code"]');
      if (!this.btn || !this.codeEl) return;
      this.code = this.dataset.code || this.codeEl.textContent.trim();
      this.copiedLabel = this.dataset.copied || 'Copiado!';
      this.originalLabel = this.codeEl.textContent;
      this.btn.addEventListener('click', () => this.copy());
    }

    async copy() {
      const text = this.code;
      try {
        await navigator.clipboard.writeText(text);
      } catch (e) {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (err) {}
        ta.remove();
      }
      this.classList.add('is-copied');
      this.codeEl.textContent = this.copiedLabel;
      clearTimeout(this._timer);
      this._timer = setTimeout(() => {
        this.codeEl.textContent = this.originalLabel;
        this.classList.remove('is-copied');
      }, 1800);
    }
  }

  if (!customElements.get('copy-coupon')) {
    customElements.define('copy-coupon', CopyCoupon);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-shipping-cep"] && !Shopify.designMode) return;
  try {
    class RegionCep extends HTMLElement {
    connectedCallback() {
      this.openBtn = this.querySelector('[data-rc-open]');
      this.overlay = this.querySelector('[data-rc-overlay]');
      this.dialog = this.overlay.querySelector('.region-cep__dialog');
      this.closeBtn = this.overlay.querySelector('[data-rc-close]');
      this.form = this.overlay.querySelector('.region-cep__form');
      this.input = this.overlay.querySelector('[name="address[zip]"]');
      this.result = this.overlay.querySelector('[data-rc-result]');
      this.submitBtn = this.overlay.querySelector('.region-cep__submit');
      this.cartUrl = this.getAttribute('data-cart-url') || '/cart';
      this._onKey = this._onKey.bind(this);
      this._controller = null;

      this.openBtn.addEventListener('click', () => this.open());
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });
      this.input.addEventListener('input', () => this.maskCep());
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.handleSubmit();
      });
      this.result.addEventListener('click', (e) => {
        if (e.target.closest('[data-rc-cta]')) {
          e.preventDefault();
          this.close();
          this.focusBuyButton();
        }
      });

      const accent = getComputedStyle(this).getPropertyValue('--rc-accent');
      if (accent) this.overlay.style.setProperty('--rc-accent', accent.trim());
      document.body.appendChild(this.overlay);
    }

    disconnectedCallback() {
      if (this.overlay && this.overlay.parentNode) {
        this.overlay.parentNode.removeChild(this.overlay);
      }
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._onKey);
    }

    open() {
      this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKey);
      this.input.focus({ preventScroll: true });
    }

    close() {
      this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._onKey);
      this.openBtn.focus();
    }

    _onKey(e) {
      if (e.key === 'Escape') this.close();
    }

    maskCep() {
      const digits = this.input.value.replace(/\D/g, '').slice(0, 8);
      this.input.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
    }

    setResult(state, html) {
      this.result.setAttribute('data-state', state);
      this.result.innerHTML = html;
      this.result.hidden = false;
    }

    inferProvince(zip) {
      const ranges = RegionCep.CEP_RANGES;
      const digits = String(zip || '').replace(/\D/g, '');
      if (digits.length < 5) return '';
      const prefix = Number(digits.slice(0, 5));
      const range = ranges.find((r) => prefix >= r[0] && prefix <= r[1]);
      return range ? range[2] : '';
    }

    esc(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    focusBuyButton() {
      const selectors = [
        'product-form button[name="add"]:not([disabled])',
        'form[action*="/cart/add"] button[name="add"]:not([disabled])',
        'form[action*="/cart/add"] [type="submit"]:not([disabled])'
      ];
      let target = null;
      for (const sel of selectors) {
        target = document.querySelector(sel);
        if (target) break;
      }
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { target.focus({ preventScroll: true }); } catch (_) { target.focus(); }
    }

    async handleSubmit() {
      const country = this.form.querySelector('[name="address[country]"]').value || 'Brazil';
      const rawZip = (this.input.value || '').trim();
      const digits = rawZip.replace(/\D/g, '');
      const province = this.inferProvince(digits);
      this.form.querySelector('[name="address[province]"]').value = province;

      if (digits.length < 8) {
        this.setResult('error', '<p>Informe um CEP válido (8 dígitos).</p>');
        return;
      }

      if (this._controller) this._controller.abort();
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.submitBtn.setAttribute('aria-busy', 'true');

      const cartJsonUrl = (this.cartUrl + '.js').replace('//.js', '/.js');
      const ratesUrl = (this.cartUrl + '/shipping_rates.json').replace(/([^:])\/\//g, '$1/');

      try {
        const cartResp = await fetch(cartJsonUrl, {
          method: 'GET',
          headers: { Accept: 'application/json' },
          signal,
          credentials: 'same-origin'
        });
        const cart = await cartResp.json();

        if (!cart || typeof cart.item_count !== 'number') {
          this.setResult('error', '<p>Não foi possível consultar o frete agora. Tente novamente.</p>');
          return;
        }

        if (cart.item_count === 0) {
          this.setResult(
            'info',
            '<p>Adicione o produto ao carrinho para calcular o frete com precisão.</p>' +
              '<p><button type="button" class="region-cep__result-cta" data-rc-cta>Adicionar ao carrinho</button></p>'
          );
          return;
        }

        const ratesResp = await fetch(ratesUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ shipping_address: { zip: digits, country, province } }),
          signal,
          credentials: 'same-origin'
        });
        const data = await ratesResp.json();

        if (data && Array.isArray(data.shipping_rates)) {
          this.renderRates(data.shipping_rates, province);
        } else {
          this.setResult('error', '<p>Não foi possível consultar o frete agora. Tente novamente.</p>');
        }
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        this.setResult('error', '<p>Não foi possível consultar o frete agora. Tente novamente.</p>');
      } finally {
        this.submitBtn.removeAttribute('aria-busy');
      }
    }

    renderRates(rates, province) {
      if (!rates.length) {
        this.setResult('error', '<p>Desculpe, não enviamos para o seu endereço.</p>');
        return;
      }
      const region = province ? ' para ' + this.esc(province) : '';
      const heading = rates.length === 1
        ? 'Frete' + region + ':'
        : 'Opções de frete' + region + ':';
      const items = rates
        .map((r) => '<li>' + this.esc(r.presentment_name) + ': ' + this.esc(r.currency) + ' ' + this.esc(r.price) + '</li>')
        .join('');
      this.setResult(
        'success',
        '<p>' + heading + '</p><ul role="list">' + items + '</ul>' +
          '<p class="region-cep__result-note">Estimativa baseada nos itens atuais do carrinho.</p>'
      );
    }
  }

  RegionCep.CEP_RANGES = [
    [1000, 19999, 'São Paulo'], [20000, 28999, 'Rio de Janeiro'], [29000, 29999, 'Espírito Santo'],
    [30000, 39999, 'Minas Gerais'], [40000, 48999, 'Bahia'], [49000, 49999, 'Sergipe'],
    [50000, 56999, 'Pernambuco'], [57000, 57999, 'Alagoas'], [58000, 58999, 'Paraíba'],
    [59000, 59999, 'Rio Grande do Norte'], [60000, 63999, 'Ceará'], [64000, 64999, 'Piauí'],
    [65000, 65999, 'Maranhão'], [66000, 68899, 'Pará'], [68900, 68999, 'Amapá'],
    [69000, 69299, 'Amazonas'], [69300, 69399, 'Roraima'], [69400, 69899, 'Amazonas'],
    [69900, 69999, 'Acre'], [70000, 72799, 'Distrito Federal'], [72800, 72999, 'Goiás'],
    [73000, 73699, 'Distrito Federal'], [73700, 76799, 'Goiás'], [76800, 76999, 'Rondônia'],
    [77000, 77999, 'Tocantins'], [78000, 78899, 'Mato Grosso'], [78900, 78999, 'Rondônia'],
    [79000, 79999, 'Mato Grosso do Sul'], [80000, 87999, 'Paraná'], [88000, 89999, 'Santa Catarina'],
    [90000, 99999, 'Rio Grande do Sul']
  ];

  if (!customElements.get('region-cep')) {
    customElements.define('region-cep', RegionCep);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["similar-products"] && !Shopify.designMode) return;
  try {
    class SimilarCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-sc-viewport]');
      this.thumb = this.querySelector('[data-sc-thumb]');
      this.openBtn = this.querySelector('[data-sc-open]');
      this.overlay = this.querySelector('[data-sc-overlay]');
      this.closeBtn = this.overlay ? this.overlay.querySelector('[data-sc-close]') : null;
      this._onKey = this._onKey.bind(this);
      this.updateProgress = this.updateProgress.bind(this);

      if (this.viewport) {
        this.viewport.addEventListener('scroll', this.updateProgress, { passive: true });
        window.addEventListener('resize', this.updateProgress);
        this.updateProgress();
        this.initDrag();
      }

      if (this.openBtn && this.overlay) {
        this.openBtn.addEventListener('click', () => this.openModal());
        this.closeBtn.addEventListener('click', () => this.closeModal());
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) this.closeModal();
        });
        document.body.appendChild(this.overlay);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.updateProgress);
      document.removeEventListener('keydown', this._onKey);
      if (this.overlay && this.overlay.parentNode) {
        this.overlay.parentNode.removeChild(this.overlay);
      }
      document.body.style.overflow = '';
    }

    openModal() {
      this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKey);
    }

    closeModal() {
      this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._onKey);
      this.openBtn.focus();
    }

    _onKey(e) {
      if (e.key === 'Escape') this.closeModal();
    }

    updateProgress() {
      if (!this.thumb) return;
      const ratio = this.viewport.clientWidth / this.viewport.scrollWidth;
      const widthPct = Math.min(100, Math.max(10, ratio * 100));
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      const progress = max > 0 ? this.viewport.scrollLeft / max : 0;
      const travel = 100 - widthPct;
      this.thumb.style.width = widthPct + '%';
      this.thumb.style.transform = 'translateX(' + (progress * travel) + '%)';
    }

    initDrag() {
      let down = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;

      this.viewport.addEventListener('pointerdown', (e) => {
        down = true;
        moved = false;
        startX = e.pageX;
        startScroll = this.viewport.scrollLeft;
      });
      this.viewport.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.pageX - startX;
        if (Math.abs(dx) > 4) {
          moved = true;
          this.viewport.classList.add('is-dragging');
        }
        if (moved) this.viewport.scrollLeft = startScroll - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!down) return;
        down = false;
        if (moved) requestAnimationFrame(() => this.viewport.classList.remove('is-dragging'));
      });
      this.viewport.addEventListener('dragstart', (e) => e.preventDefault());
    }
  }

  if (!customElements.get('similar-carousel')) {
    customElements.define('similar-carousel', SimilarCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    class SizeGuideDrawer extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.size-guide__trigger');
      this.overlay = this.querySelector('[data-sg-overlay]');
      this.panel = this.overlay.querySelector('.size-guide__panel');
      this.closeBtn = this.overlay.querySelector('[data-sg-close]');
      this.tabs = this.overlay.querySelectorAll('.size-guide__tab');
      this.rows = this.overlay.querySelectorAll('.size-guide__row');
      this._onKey = this._onKey.bind(this);

      this.trigger.addEventListener('click', () => this.open());
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.switchCategory(tab.dataset.cat));
      });

      const accent = getComputedStyle(this).getPropertyValue('--sg-accent');
      if (accent) this.overlay.style.setProperty('--sg-accent', accent.trim());
      document.body.appendChild(this.overlay);

      this.positionTrigger();
    }

    positionTrigger() {
      const wanted = (this.getAttribute('data-size-option') || 'Tamanho').trim().toLowerCase();
      const options = document.querySelectorAll('.variant-picker .variant-option');
      let legend = null;
      options.forEach((opt) => {
        const labelEl = opt.querySelector('legend, label');
        if (!labelEl) return;
        const name = (labelEl.childNodes[0] && labelEl.childNodes[0].textContent || labelEl.textContent || '')
          .trim()
          .toLowerCase();
        if (name === wanted || name.indexOf(wanted) === 0) legend = labelEl;
      });
      if (!legend) return;
      legend.classList.add('size-guide__legend');
      this.trigger.classList.add('size-guide__trigger--inline');
      legend.appendChild(this.trigger);
    }

    disconnectedCallback() {
      if (this.overlay && this.overlay.parentNode) {
        this.overlay.parentNode.removeChild(this.overlay);
      }
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._onKey);
    }

    open() {
      this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKey);
      this.panel.focus({ preventScroll: true });
    }

    close() {
      this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._onKey);
      this.trigger.focus();
    }

    _onKey(e) {
      if (e.key === 'Escape') this.close();
    }

    switchCategory(cat) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.cat === cat;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.rows.forEach((row) => {
        row.hidden = row.dataset.cat !== cat;
      });
    }
  }

  if (!customElements.get('size-guide-drawer')) {
    customElements.define('size-guide-drawer', SizeGuideDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vh-stories"] && !Shopify.designMode) return;
  try {
    if (!window.__vhStoriesLoaded) {
    window.__vhStoriesLoaded = true;

    const STORY_DURATION_MS = 4000;

    function init(widget) {
      if (!widget || widget.dataset.vhStoriesInit === '1') return;
      widget.dataset.vhStoriesInit = '1';

      const container = widget.querySelector('[data-vh-stories-container]');
      const modal = widget.querySelector('[data-vh-story-modal]');
      const video = widget.querySelector('[data-vh-story-video]');
      const closeBtns = widget.querySelectorAll('[data-vh-story-close]');
      if (!container || !modal || !video) return;

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      const items = Array.from(container.querySelectorAll('.vh-story'));
      if (!items.length) return;

      let currentIndex = 0;
      let raf = null;
      let isOpen = false;

      items.forEach((item) => {
        const ring = item.querySelector('.vh-story__ring-progress');
        if (!ring) return;
        ring.setAttribute('pathLength', '100');
        ring.style.strokeDasharray = '100';
        ring.style.strokeDashoffset = '100';
      });

      const stopRing = () => {
        if (raf) {
          cancelAnimationFrame(raf);
          raf = null;
        }
      };

      const advanceRing = () => {};

      const runRing = (index) => {
        stopRing();
        items.forEach((item, i) => {
          const p = item.querySelector('.vh-story__ring-progress');
          if (!p) return;
          if (i !== index) p.style.strokeDashoffset = '100';
        });

        const progress = items[index] && items[index].querySelector('.vh-story__ring-progress');
        if (!progress) return;

        const start = performance.now();
        const tick = (now) => {
          const fraction = Math.min((now - start) / STORY_DURATION_MS, 1);
          progress.style.strokeDashoffset = String(100 - fraction * 100);
          if (fraction < 1) {
            raf = requestAnimationFrame(tick);
          } else {
            advanceRing();
          }
        };
        raf = requestAnimationFrame(tick);
      };

      const pauseThumbs = () => {
        widget.querySelectorAll('[data-vh-thumb-video]').forEach((v) => {
          try { v.pause(); } catch (e) {}
        });
      };

      const resumeThumbs = () => {
        widget.querySelectorAll('[data-vh-thumb-video]').forEach((v) => {
          const p = v.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        });
      };

      const setupAutoplayThumbs = () => {
        const thumbs = widget.querySelectorAll('[data-vh-thumb-video]');
        if (!thumbs.length) return;

        if (!('IntersectionObserver' in window)) {
          resumeThumbs();
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const thumb = entry.target;
              if (entry.isIntersecting && !isOpen) {
                const play = thumb.play();
                if (play && typeof play.catch === 'function') play.catch(() => {});
              } else {
                try { thumb.pause(); } catch (e) {}
              }
            });
          },
          { rootMargin: '120px', threshold: 0.1 }
        );

        thumbs.forEach((thumb) => observer.observe(thumb));
      };

      const openModal = (item, index) => {
        const url = item.getAttribute('data-vh-video-url');
        if (!url) return;
        video.src = url;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        isOpen = true;
        currentIndex = index;
        video.muted = false;
        video.play().catch(() => {
          video.muted = true;
          video.play().catch(() => {});
        });
        pauseThumbs();
        runRing(index);
        document.body.style.overflow = 'hidden';
      };

      const closeModal = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        try { video.pause(); } catch (e) {}
        video.src = '';
        isOpen = false;
        stopRing();
        resumeThumbs();
        document.body.style.overflow = '';
      };

      items.forEach((item, i) => {
        item.addEventListener('click', () => openModal(item, i));
        item.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openModal(item, i);
          }
        });
      });

      closeBtns.forEach((b) => b.addEventListener('click', closeModal));
      modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
      document.addEventListener('keydown', (e) => { if (isOpen && e.key === 'Escape') closeModal(); });

      setupAutoplayThumbs();
    }

    const initAll = () => {
      document.querySelectorAll('[data-vh-stories]').forEach(init);
    };

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-vh-stories]').forEach(init);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
